import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AutoDepartmentFilterService {

  constructor(public apiService: ApiService) {}

  fetch(data: any): Promise<any> {
    return this.apiService.fetch('/department/find-user', data);
  }
}
